import React, { useEffect, useState } from "react";
import EducationBanner from "./components/EducationBanner";
import KnowledgeHub from "./components/KnowledgeHub";
import EducationSubsribeNow from "./components/EducationSubsribeNow";
import { BoardTabs } from "./components/BoardTabs";
import axios from "axios";
import BoardSelection, { EducationBoard } from "./components/BoardSelection";
import { BaseURL } from "../../services/api";
import Loader from "../../components/Loader/Loader";

export const EducationBoards = () => {
  const [educationBoards, setEducationBoards] = useState<EducationBoard[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState<string>("State");

  useEffect(() => {
    const fetchEducationBoards = async () => {
      try {
        const response = await BaseURL.get("/api/educationBoard/landing-page");
        setEducationBoards(response.data.data);

        if (response.data.data.length > 0) {
          setActiveTab(response.data.data[0].boardLevel);
        }
      } catch (err) {
        console.error("API Fetch Error:", err);
        setError("Failed to load education boards");
      } finally {
        setLoading(false);
      }
    };
    fetchEducationBoards();
  }, []);

  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <div>Error: {error}</div>;
  }

  const uniqueTabs = educationBoards.map((b) => b.boardLevel);
  const filteredBoards = educationBoards.filter(
    (b) => b.boardLevel === activeTab
  );

  return (
    <div>
      <EducationBanner boards={educationBoards} />
      <BoardTabs
        tabs={uniqueTabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />
      <BoardSelection boards={filteredBoards} />
      <KnowledgeHub />
      <EducationSubsribeNow />
    </div>
  );
};
